import BaseComponent from '../../../js/base-component'

class Contact extends BaseComponent {
    constructor(options) {
        super(options);

        let formular = document.querySelector('.u-contact__form'),

        // methods
        setup = function() {
            formular.addEventListener("submit", validateForm);
        },
        validateForm = function(evt) {
            evt.preventDefault();

            let formObj = {
                message: formular["message"].value,
                additionalMessage: formular["additionalMessage"].value,
                firstname: formular["firstname"].value,
                lastname: formular["lastname"].value,
                email: formular["email"].value,
                docId: formular["docId"].value,
                privacy: formular["privacy"].checked ? " " : "",
                __csrf_token: formular["__csrf_token"].value,
            }

            for (let item in formObj) {
                if ( item === 'email' && !formular["email"].value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g) ) {
                    formular[item].parentNode.classList.add('invalid');
                    formular[item].addEventListener("change", validateForm);
                } else if (formObj[item].length == 0 && formObj[item] !== formular["message"]) {
                    formular[item].parentNode.classList.add('invalid');
                    formular[item].addEventListener("change", validateForm);
                } else {
                    formular[item].parentNode.classList.remove('invalid');
                    formular[item].removeEventListener("change", validateForm);
                }
            }

            if ( !document.querySelectorAll('.u-contact__field.invalid').length ) {
                const alertContainer = document.querySelector('.alert-container');

                alertContainer.classList.remove('is--success');
                alertContainer.classList.remove('is--error');

                fetch(formular.getAttribute('action'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formObj),
                })
                .then(response => response.json())
                .then(function(data) {
                    if (data.success === true) {
                        alertContainer.classList.add('is--success');
                    } else {
                        alertContainer.classList.add('is--error');
                    }

                    formular.classList.add('is--hidden');
                });

                return true;
            }

            return false;
        };

        if (formular) {
            setup();
        }
    }
}

export default {
    definition: Contact,
    name: "Contact",
};